import {
  Flexbox, ListManager, PageHeader, Styles,
} from '@/components'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import usePageTitle from '@/hooks/usePageTitle'
import useQuery from '@/hooks/useQuery'
import reports from '@/services/api/reports'
import React from 'react'
import FilterClinicalCares from '../../components/FilterClinicalCares'
import CardHeader from '../components/CardHeader'
import CardItem from '../components/CardItem'

function ClinicalCaresByPriority({ title }) {
  usePageTitle({ title })
  const query = useQuery()
  const { data, loading, error } = useAxiosRequest(reports.clinicalCaresByPriority, query)

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Atendimentos clínicos por prioridade"
        subtitle="Quantidade de atendimentos clínicos por prioridade, do nível mais alto para o mais baixo"
        icon="fas fa-exclamation-triangle"
        rightAction={() => <FilterClinicalCares />}
      />
      <ListManager count={data?.rows?.length || 0} loading={loading} error={error}>
        {Boolean(data) && (
          <Flexbox.Columns>
            {data.rows.map((item) => (
              <Flexbox.Column key={item?.priorityId || 'without-priority'} className="col-6 col-sm-12 my-2">
                <CardItem
                  item={item}
                  statusList={data?.statusList}
                  style={item?.color ? { borderTop: `4px solid ${item.color}` } : undefined}
                  header={(
                    <CardHeader
                      title={(
                        <>
                          {Boolean(item?.color) && (
                            <i className="fas fa-circle mr-2" style={{ color: item.color }} />
                          )}
                          {item?.title || 'Atendimentos sem prioridade'}
                        </>
                      )}
                      subtitle={item?.level !== undefined && item?.level !== null ? `Nível ${item.level}` : null}
                    />
                  )}
                />
              </Flexbox.Column>
            ))}
          </Flexbox.Columns>
        )}
      </ListManager>
    </Styles.Container>
  )
}

export default ClinicalCaresByPriority
